import React, { useState } from 'react';
import { Button, Grid } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { isValidDate } from '../../utils/Common';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import moment from 'moment';
import Loader from '../Common/Loader';
import { setStoreData } from '../../Redux/actions';
import AlertDialog from '../Common/AlertDialog';

export default function SyncSummaryData() {

    const dispatch = useDispatch();
    const { client_id, id } = useParams();

    const [errors, setErrors] = useState({});
    const [fromDate, setFromDate] = useState(null)
    const [toDate, setToDate] = useState(null)
    const [showLoader, setShowLoader] = useState(false)
    const [alertMessage, setAlertMessage] = useState();
    const [msgType, setMsgType] = useState("success");

    const validateData = () => {
        const err = {};
        let hasErrors = false;

        if (!fromDate) {
            hasErrors = true;
            err.fromDate = 'This field is mandatory';
        } else if (!isValidDate(fromDate)) {
            hasErrors = true;
            err.fromDate = 'Please enter a valid date in DD/MM/YYYY format';
        } else if (dayjs(fromDate).isAfter(dayjs())) {
            hasErrors = true;
            err.fromDate = 'Future date cannot be selected';
        }

        if (!toDate) {
            hasErrors = true;
            err.toDate = 'This field is mandatory';
        } else if (!isValidDate(toDate)) {
            hasErrors = true;
            err.toDate = 'Please enter a valid date in DD/MM/YYYY format';
        } else if (dayjs(toDate).isAfter(dayjs())) {
            hasErrors = true;
            err.toDate = 'Future date cannot be selected';
        }

        if (fromDate && toDate) {
            if (dayjs(fromDate).isAfter(dayjs(toDate))) {
                hasErrors = true;
                err.fromDate = 'From Date cannot be greater than To Date';
            }

            if (dayjs(toDate).diff(dayjs(fromDate), 'day') > 14) {
                hasErrors = true;
                err.toDate = 'Maximum 15 days can be selected';
            }
        }

        setErrors(err);
        return !hasErrors;
    };

    const handleStartSync = async () => {
        setShowLoader(true)
        const isValid = validateData(); 
        if (!isValid) {
            setShowLoader(false)
            return; 
        }
        const params = {
            'start_date': moment(fromDate).format('YYYY-MM-DD'),
            'end_date_param': moment(toDate).format('YYYY-MM-DD'),
            "pid": id
        }
        await axios.get(`/papi/v1/sync_summary_table_data/`, { params })
            .then((response) => {
                if (!response) {
                    setShowLoader(false)
                    return
                } else {
                    updateResponse(response, response?.data?.message);
                    setShowLoader(false)
                }
            })
            .catch((error) => {
                console.error('Something went wrong:', error);
                setShowLoader(false)
            });
    }

    const updateResponse = (resp, message) => {
        const res = resp && resp.data;
        let msg = res.message;
        let type = "fail";
        if (res && res.success) {
            msg = message;
            type = "success";
        }
        dispatch(setStoreData('alertMessage', {
            msg, type,
            handleClose: () => handleCloseDialog(),
        }))
    };

    const handleCloseDialog = () => {
        dispatch(setStoreData('alertMessage', null))
    }

return (
    <div className="main w3-padding-large">
            <div>
                <Grid container spacing={2}>
                    <Grid item className='w3-margin-bottom'>
                        <h5 className="card-title">Sync Summary Data</h5>
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='w3-margin-bottom'>
                    <Grid item md={3}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
                            <DatePicker
                                label="From Date*"
                                format="DD/MM/YYYY"
                                slotProps={{ 
                                    textField: { 
                                        fullWidth: true, 
                                        error: false, 
                                        size: 'small', 
                                        sx: { 
                                            '& .MuiInputBase-root': { height: 40 },
                                            '& .MuiInputLabel-shrink': { top: 0 }
                                        }  
                                    } 
                                }}
                                name="fromDate"
                                value={fromDate ? dayjs(fromDate) : null}
                                onChange={(newValue) => {
                                    setFromDate(dayjs(newValue).toDate())
                                
                                    if (errors.fromDate === 'From Date cannot be greater than To Date' || errors.toDate === 'Maximum 15 days can be selected' ) {
                                        setErrors({ ...errors, fromDate: null, toDate: null });
                                    } else {
                                        setErrors({ ...errors, fromDate: null });
                                    }
                                }}
                                maxDate={dayjs()}
                            />
                        </LocalizationProvider>
                        {errors.fromDate && <div className='error-text w3-margin-bottom'>{errors.fromDate}</div>}
                    </Grid>
                    <Grid item md={3} >
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
                            <DatePicker
                                label="To Date*"
                                format="DD/MM/YYYY"
                                slotProps={{ 
                                    textField: { 
                                        fullWidth: true, 
                                        error: false, 
                                        size: 'small', 
                                        sx: { 
                                            '& .MuiInputBase-root': { height: 40 },
                                            '& .MuiInputLabel-shrink': { top: 0 }
                                        }  
                                    } 
                                }}
                                name="toDate"
                                value={toDate ? dayjs(toDate) : null}
                                onChange={(newValue) => {
                                    setToDate(dayjs(newValue).toDate())
                                    if (errors.toDate === 'Maximum 15 days can be selected' || errors.fromDate === 'From Date cannot be greater than To Date' ) {
                                        setErrors({ ...errors, fromDate: null, toDate: null });
                                    } else {
                                        setErrors({ ...errors, toDate: null });
                                    }
                                }}
                                maxDate={dayjs()}
                                minDate={fromDate ? dayjs(fromDate) : null}
                            />
                        </LocalizationProvider>
                        {errors.toDate && <div className='error-text w3-margin-bottom'>{errors.toDate}</div>}
                    </Grid>
                    <Grid item>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ height: '40px'}}
                            onClick={handleStartSync}
                            disabled={!fromDate || !toDate}
                        >
                            START SYNCING
                        </Button>
                    </Grid>
                </Grid>
                {alertMessage ?
                    (
                        <AlertDialog
                            handleClose={handleCloseDialog}
                            message={alertMessage}
                            type={msgType}
                            handleDialogClose={() => setAlertMessage(null)}
                        />
                    )
                    : null
                }
                {showLoader && <Loader open={showLoader} msg="Please wait...Syncing in progress!"/>} 
            </div>
        </div>  
    )
}